// app/javascript/controllers/hr_portal/progress_bar_controller.js
import { Controller } from '@hotwired/stimulus'
import { cn } from '../../lib/utils'

export default class extends Controller {
  static targets = ['bar']

  connect() {
    const prevClassList = Array.from(this.element.classList)
    const newClasses = [
      'mt-2',
      'h-2',
      'w-full',
      'rounded-full',
      'bg-mine-shaft-100',
      'overflow-hidden',
    ]
    this.element.className = cn(...newClasses, ...prevClassList)
    this.createBar()
  }

  barTargetConnected(element) {
    // Ensure we start at 0
    element.style.width = '0%'

    // Force the browser to apply the initial width before transitioning
    element.getBoundingClientRect()

    // Next frame: set the final width (this triggers the transition)
    requestAnimationFrame(() => {
      element.style.width = `${this.element.dataset.value}%`
    })
  }

  createBar() {
    const bar =
      this.element.querySelector('div.progress-bar') ||
      document.createElement('div')
    bar.style.width = '0%'
    const prevClassList = Array.from(bar.classList)
    const newClasses = [
      'progress-bar',
      'h-full',
      'rounded-full',
      'transition-[width]',
      'duration-700',
    ]
    bar.className = cn(...newClasses, ...prevClassList)
    bar.style.backgroundColor = this.element.dataset.color
    bar.dataset.hrPortalProgressBarTarget = 'bar'
    this.element.innerHTML = ''
    this.element.appendChild(bar)
  }
}
